import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import {
	iconArrowUpward,
	iconControlPointDuplicate,
	iconSupervisorAccount,
	iconVisibility,
} from '@change-corgi/design-system-legacy/icons';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { usePromotionHistory } from './hooks/usePromotionHistory';

export function PromotionHistory(): JSX.Element {
	const { data } = usePromotionHistory();

	return (
		<div className="flex flex-col gap-6 px-4 md:px-12">
			<div className="flex items-center gap-1">
				<Text variant="heading" className="text-size-heading-xs md:text-size-heading-small">
					<Translate value="corgi.petition.starter_dashboard.petition_insights.promotion_history.title" />
				</Text>
				<InfoTooltip aria-describedby="petition-insights-title">
					<Translate
						value={`corgi.petition.starter_dashboard.petition_insights.promotion_history.tip${
							data.shouldUseDonationLanguage ? '_donation' : ''
						}`}
					/>
				</InfoTooltip>
			</div>

			<div className="flex flex-col flex-nowrap gap-4 md:flex-row md:flex-wrap md:gap-6">
				<div className="flex items-center">
					<Icon className="text-icon-information" mr="8px" size={24} icon={iconArrowUpward} />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.promoter"
							replacements={{ promoterCount: data.promoterCountFormatted }}
							count={data.promoterCount}
						/>
					</Text>
				</div>
				<div className="flex items-center">
					<Icon className="text-icon-information" mr="8px" size={24} icon={iconControlPointDuplicate} />
					<Text as="span">
						<Translate
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.contributions"
							replacements={{ contributorCount: data.contributionsFormatted }}
						/>
					</Text>
				</div>
				<div className="flex items-center">
					<Icon className="text-icon-information" mr="8px" size={24} icon={iconVisibility} />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.petition_view"
							replacements={{ petitionViewCount: data.impressionsTotalFormatted }}
							count={data.impressionsTotal}
						/>
					</Text>
				</div>
				<div className="flex items-center">
					<Icon className="text-icon-information" mr="8px" size={24} icon={iconSupervisorAccount} />
					<Text as="span">
						<TranslatePlural
							value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_history.signature"
							replacements={{ signatureCount: data.signatureCountFormatted }}
							count={data.signatureCount}
						/>
					</Text>
				</div>
			</div>
		</div>
	);
}
